export default __webpack_public_path__ + "static/media/column-width.9dca4c54.svg";